import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

import { AuthService } from '../auth.service';
import { UserService } from '../../user/user.service';
import { User } from '../../user/user.model';

import 'rxjs/add/operator/map';
import { UserRole } from '../roles.enum';


@Injectable()
export class AuthJWTService {

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    public jwtHelper: JwtHelperService
  ) {
    // const token = this.getToken();
    // console.log('do we have a token?', token);
    // if (token) {
    //   const decodedUser = this.authService.decodeUserFromToken(token).user;
    //   console.log('this is the decoded user from the jwt constructor', decodedUser);
    //   this.authService.setCurrentUserFromId(decodedUser);
    // }
  }

  getToken(): string {
    return this.jwtHelper.tokenGetter();
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    if (token) {
      return !this.jwtHelper.isTokenExpired(token);
    } else {
      return false;
    }
  }

  login(emailAndPassword) {

    return this.userService.login(emailAndPassword).map(
      res => {
        // console.log('userToken', res.userToken);
        localStorage.setItem('userToken', res.userToken);
        const decodedUser = this.authService.decodeUserFromToken(res.token).user;
        this.authService.setCurrentUserFromId(decodedUser);
        return this.isAuthenticated();
      },
      err => {
        console.log(err);
      }
    );
  }

  logout() {
    this.authService.clearUser();
    this.router.navigate(['/']);
  }

}



// WEBPACK FOOTER //
// ./client/app/core/auth/jwt/auth-jwt.service.ts